export default "__VITE_ASSET__EwRm$CBj__"